import React from "react";

const Todo = ({ text, todo, todos, setTodos }) => {
    const checkBtnHandler = (e) => {
        setTodos(
            todos.map((item) => {
                if (item.id === todo.id) {
                    return {
                        ...item,
                        completed: !item.completed,
                    };
                }
                return item;
            })
        );
    };

    const delBtnHandler = (e) => {
        setTodos(todos.filter((el) => el.id !== todo.id));
    };

    return (
        <div className="todo">
            <li className={`todo-item ${todo.completed ? "completed" : ""}`}>{text}</li>
            <button onClick={checkBtnHandler} className="complete-btn">
                <i className="fas fa-check"></i>
            </button>
            <button onClick={delBtnHandler} className="delete-btn">
                <i className="fas fa-trash"></i>
            </button>
        </div>
    );
};

export default Todo;
